<!-- <script>
import { useLayoutStore } from "~/stores/layout";
import { LAYOUT_TYPE } from "~/app/const";
import Vertical from "~/components/layouts/vertical/index.vue";
import Horizontal from "~/components/layouts/horizontal/index.vue";

export default {
  data() {
    return {
      LAYOUT_TYPE
    };
  },
  created() {
    if (process.client) {
         document.body.removeAttribute("data-layout");
   document.body.removeAttribute("data-topbar");
   document.body.removeAttribute("data-layout");
    document.body.setAttribute("data-layout", "vertical");
        }  
   
  },
  components: {
    Vertical,
    Horizontal
  },
  computed: {
    ...useLayoutStore(),
    layoutType() {
      return useLayoutStore() ? useLayoutStore().layoutType : {};
    },
    isVertical() {
      return this.layoutType === LAYOUT_TYPE.VERTICAL;
    },
    isHorizontal() {
      return this.layoutType === LAYOUT_TYPE.HORIZONTAL;
    }
  },
  mounted() {
   // document.body.classList.remove("authentication-bg");
  }
};
</script> -->

<template>
  <div>
    <ClientOnly>
      <Vertical >
        <slot />
      </Vertical>
     
    </ClientOnly>
  </div>
</template>
<script setup>

import { computed } from 'vue'
import { useLayoutStore } from '~/stores/layout'
import { LAYOUT_TYPE } from '~/app/const'

import Vertical from '~/components/layouts/vertical/index.vue'
import Horizontal from '~/components/layouts/horizontal/index.vue'

const layoutStore = useLayoutStore()

const layoutType = computed(() => layoutStore.layoutType)
const isVertical = computed(() => layoutType.value === LAYOUT_TYPE.VERTICAL)
const isHorizontal = computed(() => layoutType.value === LAYOUT_TYPE.HORIZONTAL)
const isLightMode = computed(() => layoutStore.mode === 'light')

onMounted(() => {
  if (process.client) {
    document.body.removeAttribute('data-layout')
    document.body.removeAttribute('data-topbar')
    document.body.setAttribute('data-layout', 'vertical')
  }
})
</script>
